import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useNavigate } from 'react-router-dom';
import { API_URL } from './config';
import XGolifeDashboardComponent from './components/XGolifeDashboardComponent';

const Dispatch = () => {
    const [tripId, setTripId] = useState('');
    const [confirmCode, setConfirmCode] = useState('');
    const [loading, setLoading] = useState(false);
    const [items, setItems] = useState([]);
    const navigate = useNavigate();

    const fetchProducts = async (trip_id, code) => {
        setLoading(true);
        try {
            const response = await fetch(`${API_URL}/salelist/dispatch/${trip_id}/${code}`);
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const data = await response.json();

            // Format the data to include relevant fields
            const formattedData = data.map(item => ({
                id: item.product_id,
                productCode: item.product_code,
                description: item.description_notes,
                productName: item.product_name || 'N/A',
                unitCost: item.unit_cost || 0,
                quantity: item.quantity || 0,
                tripId: item.trip_id,
                companyId: item.company_id,
                branchId: item.branch_id,
            }));

            setItems(formattedData);
            // Use the first item to get companyId and branchId
            if (formattedData.length > 0) {
                navigate("/DriverConfirmDispatch", { 
                    state: { 
                        items: formattedData, 
                        tripId: formattedData[0].tripId, 
                        companyId: formattedData[0].companyId, 
                        branchId: formattedData[0].branchId 
                    } 
                });
            }
        } catch (error) {
            console.error('Error fetching products:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleCodeSubmit = () => {
        fetchProducts(tripId, confirmCode);
    };

    return (
        <XGolifeDashboardComponent>
            <div className="d-flex flex-column min-vh-100" style={{ backgroundColor: '#fff' }}>
                <div className="d-flex flex-grow-1">
                    <div className="flex-grow-1 p-3" style={{ 
                        backgroundColor: '#fff', 
                        overflowY: 'auto', 
                        maxHeight: 'calc(100vh - 56px)', 
                    }}>
                        <div className="container">
                            <div className="row mb-3" style={{ marginTop: '50px' }}>
                                <div className="col">
                                    <h4 className="text-secondary" style={{ fontSize: '1.2rem' }}>
                                        Dispatch Management
                                    </h4>
                                </div>
                            </div>

                            <div className="card shadow-sm mb-3" style={{ borderColor: '#f0f0f0' }}>
                                <div className="card-body">
                                    <div className="row align-items-center mb-3">
                                        <div className="col-md-6">
                                            <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                placeholder="Enter Trip ID"
                                                value={tripId}
                                                onChange={(e) => setTripId(e.target.value)}
                                                style={{ 
                                                    fontSize: '0.875rem',
                                                    height: '35px',
                                                    borderColor: '#e0e0e0'
                                                }}
                                            />
                                        </div>
                                        <div className="col-md-6">
                                            <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                placeholder="Enter Driver Confirmation Code"
                                                value={confirmCode}
                                                onChange={(e) => setConfirmCode(e.target.value)}
                                                style={{ 
                                                    fontSize: '0.875rem',
                                                    height: '35px',
                                                    borderColor: '#e0e0e0'
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-6 text-md-end mt-3 mt-md-0">
                                        <button
                                            className="btn btn-sm"
                                            onClick={handleCodeSubmit}
                                            style={{ 
                                                backgroundColor: '#DAA520',
                                                color: '#fff',
                                                fontSize: '0.875rem',
                                                padding: '0.375rem 1rem'
                                            }}
                                        >
                                            Fetch Dispatch Items
                                        </button>
                                    </div>

                                    {loading && (
                                        <div className="text-center py-3">
                                            <div className="spinner-border spinner-border-sm" 
                                                style={{ color: '#DAA520' }} 
                                                role="status">
                                                <span className="visually-hidden">Loading...</span>
                                            </div>
                                        </div>
                                    )}

                                    {items.length > 0 && (
                                        <div className="table-responsive mt-3">
                                            <table className="table table-hover">
                                                <thead className="table-light">
                                                    <tr>
                                                        <th>Product ID</th>
                                                        <th>Product Code</th>
                                                        <th>Description</th>
                                                        <th>Product Name</th>
                                                        <th>Unit Cost</th>
                                                        <th>Quantity</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {items.map(item => (
                                                        <tr key={item.id}>
                                                            <td>{item.id}</td>
                                                            <td>{item.productCode}</td>
                                                            <td>{item.description}</td>
                                                            <td>{item.productName}</td>
                                                            <td>${item.unitCost.toFixed(2)}</td>
                                                            <td>{item.quantity}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </XGolifeDashboardComponent>
    );
};

export default Dispatch;